import { createSlice } from '@reduxjs/toolkit';
import { getDepartmentListThunk } from './Department.thunk';

export const departmentSlice = createSlice({
  name: 'department',
  initialState: {
    list: {
      items: [],
      pagination: {},
      loading: true,
    },
  },
  reducers: {
    resetDepartmentListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        pagination: {},
      },
    }),
  },
  extraReducers: builder => {
    // Start Department list
    builder.addCase(getDepartmentListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getDepartmentListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = { ...state.list, items: data, pagination, loading: false };
    });
    builder.addCase(getDepartmentListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Department list
  },
});

export const getDepartmentList = (state: any) => state.department.list;

export default departmentSlice.reducer;
